var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgOriginIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 30,
    viewBox: "0 0 30 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_157_24259)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M14.9998 10.1533C13.4178 10.1533 12.1318 11.4403 12.1318 13.0233C12.1318 14.6053 13.4178 15.8913 14.9998 15.8913C16.5818 15.8913 17.8668 14.6053 17.8668 13.0233C17.8668 11.4403 16.5818 10.1533 14.9998 10.1533Z",
    fill: "#F58B7F"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M20.039 15.277C18.658 18.297 16.011 21.488 15.233 22.393C15.174 22.46 15.091 22.5 15 22.5C14.911 22.5 14.824 22.46 14.769 22.393C13.989 21.488 11.342 18.297 9.961 15.277C9.642 14.575 9.478 13.816 9.478 13.023C9.478 9.977 11.956 7.5 15 7.5C18.045 7.5 20.522 9.977 20.522 13.023C20.522 13.816 20.36 14.575 20.039 15.277ZM15 0C6.716 0 0 6.716 0 15C0 23.284 6.716 30 15 30C23.285 30 30 23.284 30 15C30 6.716 23.285 0 15 0Z",
    fill: "#F58B7F"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_157_24259"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 30,
    height: 30,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgOriginIcon);
export default __webpack_public_path__ + "static/media/origin-icon.883c32ceffaccd67a6850ebba49626ee.svg";
export { ForwardRef as ReactComponent };